import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { GetUnreadNotificationsByUserId } from 'app/core/models/notification/unread-notifications-by-user-id.model';
import { BaseApiResponse } from 'app/core/models/api/api.model';
import { GetAllNotificationsByUserId } from 'app/core/models/notification/get-all-notifications-by-user-id.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private apiService: ApiService) {}

  private apiURL = `${environment.apiLocations.communication}/notifications`;

  getUnreadNotificationsByUserId(
    userId: string
  ): Observable<BaseApiResponse<GetUnreadNotificationsByUserId[]>> {
    return this.apiService.get<GetUnreadNotificationsByUserId[]>(
      `${this.apiURL}/getUnreadNotificationsByUserId?UserId=${userId}`
    );
  }

  getAllNotificationsByUserId(
    pageIndex: number,
    pageSize: number
  ): Observable<BaseApiResponse<GetAllNotificationsByUserId>> {
    return this.apiService.get<GetAllNotificationsByUserId>(
      `${this.apiURL}/getAllNotificationsByUserId?pageIndex=${pageIndex}&pageSize=${pageSize}`
    );
  }

  markNotificationsAsRead(body: { id: string }) {
    return this.apiService.post(`${this.apiURL}/markNotificationsAsRead`, body);
  }
}
